var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmergency = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.5-147.09v-91h65.43l76.61-255.11q8.96-29.34 33.33-47.12 24.37-17.77 54.2-17.77h111.86q29.83 0 54.2 17.77 24.37 17.78 33.33 47.12l76.61 255.11h65.43v91h-571Zm240-494.82v-211h91v211h-91ZM685.41-536.7l-64.89-64.89 149.89-148.89 63.66 63.89L685.41-536.7Zm43.68 182.2v-91h211v91h-211Zm-454.5-182.2L125.93-686.59l63.66-63.89 149.89 148.89-64.89 64.89ZM19.91-354.5v-91h211v91h-211Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmergency, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emergency.b5e64cd4.svg";
export { ForwardRef as ReactComponent };